class VgHelpers {


	static showModalCountryChange(selectedGymCountry){
		let modal_description = JoiningVars.get_form_field("modals").change_country.content;
		let countryIndex = selectedGymCountry.toLowerCase();
		modal_description = modal_description.replace('[COUNTRY]', JoiningVars.get_form_field("countries")[countryIndex]);
		new VgModal({
			title: JoiningVars.get_form_field("modals").change_country.title,
			description: modal_description,
			data: [],
			type: "error",
			template: "basic",
		});
	}

	static getCountryAndLanguage() {
		const countryLanguage = this.getActualDomain();

		const country = countryLanguage.split('-')[0];
		const lang = countryLanguage.split('-')[1];
		return { country, lang };
	}

	static getCountry() {
		const countryLanguage = this.getCountryAndLanguage();
		return countryLanguage.country;
	}

	static getLanguage() {
		const countryLanguage = this.getCountryAndLanguage();
		return countryLanguage.lang;
	}

	static getActualDomain() {
		const path = window.location.pathname;
		const countryDomain = path.split('/')[1];

		return countryDomain;
	}

	static getSelectedSlugForJoining(key){
		let initUrl = JoiningVars.get_setting_field(key, this.getActualDomain());

		const finalUrl = this.addEndSlash(initUrl);
		return '/'+ this.getActualDomain() +'/'+ finalUrl;
	}

	static formatNumberToPrice(price) {
		const lang = this.getLanguage() + '-' + this.getCountry().toUpperCase();
		const options = { style: 'currency', currency: 'EUR' };
		return new Intl.NumberFormat(lang, options).format(price);
	}

	static formatDate(date) {
		const dateObj = new Date(date);
		const lang = this.getLanguage() + '-' + this.getCountry().toUpperCase();
		const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
		return dateObj.toLocaleDateString(lang, options).replace(/\//g, '-');
	}

	static addEndSlash(initUrl){
		let lastChar = initUrl.slice(-1);
		if (lastChar !== '/') {
			return initUrl + '/';
		} else {
			return initUrl;
		}
	}

	static scrollToTop() {
		window.scrollTo({
			top: 0,
			behavior: "smooth"
		});
	}

}
